import React from 'react';
import PropTypes from 'prop-types';

/* eslint react/no-danger: 0 */
const IntroTextContainer = ({ html }) => (
    <div
        className="bg-gray-100 p-2 mb-1"
        dangerouslySetInnerHTML={{
            __html: html
        }}
    />
);

IntroTextContainer.propTypes = {
    html: PropTypes.string
};

export default IntroTextContainer;
